/**
 * FamiliarisationPaperMode - Paper mode settings component
 */
import React from 'react';
import { AlertCircle } from 'lucide-react';

const FamiliarisationPaperMode = ({ paperMode, setPaperMode }) => {
  return (
    <div className="space-y-6">
      <div className="rounded-lg bg-amber-50 border border-amber-200 p-6">
        <h3 className="text-lg font-medium text-gray-900 mb-4">Paper Record Mode</h3>
        <p className="text-sm text-gray-700 mb-4">
          Enable this mode if your crew uses paper checklists for familiarisation. 
          The app will only show the sign-off section, allowing you to record completion 
          without duplicating the paper process.
        </p>
        
        <div className="flex items-start gap-3">
          <input
            type="checkbox"
            id="paper-mode-toggle"
            checked={paperMode}
            onChange={(e) => setPaperMode(e.target.checked)}
            className="mt-1 h-4 w-4 rounded border-gray-300 text-amber-600 focus:ring-amber-600"
          />
          <div>
            <label htmlFor="paper-mode-toggle" className="block text-sm font-medium text-gray-900 cursor-pointer">
              Enable Paper Mode
            </label>
            <p className="text-xs text-gray-600 mt-1">
              When enabled, familiarisation will skip directly to the sign-off page.
            </p>
          </div>
        </div>

        {paperMode && (
          <div className="mt-4 p-4 bg-white rounded-lg border border-amber-300">
            <div className="flex items-start gap-2">
              <AlertCircle className="h-5 w-5 text-amber-600 mt-0.5" />
              <div>
                <p className="text-sm font-medium text-gray-900">Paper Mode Active</p>
                <p className="text-xs text-gray-600 mt-1">
                  Crew members will see a notice that they should complete their paper checklist 
                  before signing off in the app. The digital checklist items will not be displayed.
                </p>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="rounded-lg bg-gray-50 border border-gray-200 p-6">
        <h4 className="text-sm font-medium text-gray-900 mb-3">Benefits of Paper Mode</h4>
        <ul className="space-y-2 text-sm text-gray-700">
          <li className="flex items-start gap-2">
            <span className="text-green-600 mt-0.5">✓</span>
            <span>Maintain existing paper-based procedures while gaining digital record keeping</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="text-green-600 mt-0.5">✓</span>
            <span>Reduce duplicate work for crew already using paper checklists</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="text-green-600 mt-0.5">✓</span>
            <span>Still maintain compliance with digital signatures and timestamps</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="text-green-600 mt-0.5">✓</span>
            <span>Export digital records for audits and inspections</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default FamiliarisationPaperMode;